module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.1e59d23.ttf";